<template>
  <div class="bg-top bg-no-repeat bg-contain h-full mx-auto">
    <div v-html="info.productInfoContent" class="ql-editor ql-snow" >
    </div>
    <!-- <img :src="`${publicPath}products/${productName}.jpg`" /> -->
    <div class="w-full flex justify-end">
      <a
        :href="info.fileUrl"
        target="_blank"
        class="px-6 py-3 my-4 mr-4 bg-blue-900 text-white rounded flex items-center justify-center"
      >
        <span class="flex-grow text-sm mr-2">下载产品手册</span>
        <i class="flex-no-grow">
          <svg
            class="w-6 h-6 text-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z"
              clip-rule="evenodd"
            />
          </svg>
        </i>
      </a>
    </div>
  </div>
</template>
<script>
import { sulzerproduct } from "@/api/index";

export default {
  name: "hello",
  data() {
    return {
      productId: null,
      publicPath: process.env.BASE_URL,
      info: {},
    };
  },
  created() {
    this.productId = this.$route.query.productId;
    this.fetchData();
  },

  methods: {
    async fetchData() {
      const { data } = await sulzerproduct(this.productId || "");
      this.info = data;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.ql-align-right {
  padding-right: 0 !important;

  a {
    img {
      display: inline-block !important;
    }
  }
}
.ql-editor{
  overflow:unset!important;
  height: auto;
}
</style>
